/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/rewards/redemption_account';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "ListRedemptionAccountsRequest": {
                "fields": {
                  "planToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListRedemptionAccountsResponse": {
                "fields": {
                  "redemptionAccounts": {
                    "type": ".squareup.corporate_card.resources.rewards.RedemptionAccount",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ListRedemptionAccountsRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ListRedemptionAccountsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListRedemptionAccountsRequest @ squareup/corporate_card/service/list_redemption_accounts.proto at 10:1
 */
export const ListRedemptionAccountsRequest = $root.lookupType('squareup.corporate_card.service.ListRedemptionAccountsRequest');
fixType(ListRedemptionAccountsRequest, {
  planToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(ListRedemptionAccountsRequest);
/**
 * SOURCE ListRedemptionAccountsResponse @ squareup/corporate_card/service/list_redemption_accounts.proto at 21:1
 */
export const ListRedemptionAccountsResponse = $root.lookupType('squareup.corporate_card.service.ListRedemptionAccountsResponse');
fixType(ListRedemptionAccountsResponse);
Builder.createAndAttachToType(ListRedemptionAccountsResponse);